<template>
  <div class="main-wrap">
    <div class="top-area flex-center-between">
      <div class="flex-center">
        <img class="mr20 image-user" src="@/assets/user/image-user.png" alt/>
        <div class="info-area fz14">
          <div class="lh25">{{ $store.state.account.user.name }}</div>
          <div class="lh25 fc9">{{ $store.state.account.user.code }}</div>
        </div>
      </div>
      <div>
        <el-button type="primary" icon="el-icon-s-promotion" class="sign-button mr20 fz15"
                   @click="handleApply">{{ $store.state.account.user.type == 1 ? '申领私章' : '申领公章' }}
        </el-button>
        <el-button type="primary" icon="el-icon-s-cooperation" class="sign-button mr20 fz15"
                   v-if="$store.state.account.user.type == 1"
                   @click="handleAuthentication">企业认证
        </el-button>
      </div>
    </div>
    <div class="content flex">
      <div class="left-content">
        <div class="left-top mb25">
          <div class="flex-center">
            <img class="title-icon" src="@/assets/user/icon-sign.png" alt/>
            <div class="fz16 ml15">签署完成</div>
          </div>
          <div class="mt60 flex-center-center">
            <img class="w80 mr50" src="@/assets/user/image-sign-finish.png" alt/>
            <div class="flex-dir-center">
              <div class="fz36">{{ sealCount }}</div>
              <div class="fc9 fz18">总数量</div>
            </div>
          </div>
        </div>
        <div class="left-top flex-dir">
          <div class="flex-center-between">
            <div class="flex-center">
              <img class="title-icon" src="@/assets/user/icon-private-seal.png" alt/>
              <div class="fz16 ml15">{{ $store.state.account.user.type == 1 ? '我的私章' : '我的印章' }}</div>
            </div>
            <div class="fz14 fc-407FFF pointer" @click="goPrivate">管理 ></div>
          </div>
          <div class="flex-dir-center-center flex1">
            <img v-if="!sealData.sealImage" class="w200 mb20 mt60" src="@/assets/user/image-private-seal.png" alt/>
            <div v-else class="seal-img mt20 mb20">
              <img :src="sealData.sealImage" class="w200" alt="">
            </div>
            <div class="fz14 fc9">{{ $store.state.account.user.type == 1 ? '个人私章' : '电子公章' }}</div>
          </div>
        </div>
      </div>
      <div class="right-content flex1">
        <div class="flex-center-between">
          <div class="flex-center">
            <img class="title-icon" src="@/assets/user/icon-docu.png" alt/>
            <div class="fz16 ml15">签署记录</div>
          </div>
          <div class="fz14 fc-407FFF pointer" @click="handleMore">更多 ></div>
        </div>
        <el-table :data="signList" style="width: 100%" height="480" v-loading="loading">
          <el-table-column prop="sealCode" label="印章编码" width="135"></el-table-column>
          <el-table-column prop="sealName" label="印章名称" min-width="180"></el-table-column>
          <el-table-column prop="docFileName" label="文档名称"></el-table-column>
          <el-table-column prop="createTime" label="签署时间" width="180"></el-table-column>
          <template slot="empty">
            <div class="table_empty">
              <img src="@/assets/user/image-empty.png"/>
              <div class="fc6">还没有签署记录哦</div>
            </div>
          </template>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      sealData: {},
      sealCount: 0,
      signList: [],
      loading: false
    };
  },
  watch: {
    '$store.state.account.user': function (newValue, oldValue) {
      this.getESealInfo()
      this.getCount()
    }
  },
  mounted() {
    this.getInfo()
    // this.getESealInfo()
    // this.getCount()
  },
  methods: {
    handleAuthentication() {
      this.$router.push({
        path: "/authentication",
      });
    },
    getInfo() {
      this.loading = true
      console.log(this.$store.state.account)
      // if (!this.$store.state.account.user){
      this.$http.get(this.$api.user.getInfo).then(res => {
        //判断登录类型是个人还是企业，用户账户信息中基本信息的展示
        let temp = res.data.data
        temp.type = 1
        this.$store.commit("account/setUser", temp);
      })
      // }
    },
    getCount() {
      this.$http.get(this.$api.user.getSignatureLog).then(res => {
        this.loading = false
        if (res.data.code == 200) {
          this.signList = res.data.rows
          this.sealCount = res.data.total
        }
      })
    },
    getESealInfo() {
      this.$http.get(this.$api.user.getEsealImg).then(res => {
        if (res.data.code == 200) {
          this.sealData = res.data.data
          this.sealData.sealImage = 'data:image/jpeg;base64,' + this.sealData.sealImage
        } else {
          this.sealData = {}
        }
      })
    },
    goPrivate() {
      this.$router.push({
        path: "/userCenter/myPrivateSeal",
      });
    },
    handleMore() {
      this.$router.push({
        path: "/document",
      });
    },
    handleCheck() {
      this.$router.push({
        path: "/document",
      });
    },
    handleApply() {
      if (this.$store.state.account.user.type == 1) {
        this.$router.push({
          path: "/register/sealConfirm",
        });
      } else {
        this.$router.push({
          path: "/register/officialConfirm",
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.top-area {
  width: 100%;
  margin-top: 40px;
  padding: 30px;
  background: #fff;
  border-radius: 4px;

  .info-area {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
  }

  .image-user {
    width: 43px;
    height: 50px;
  }

  .lh25 {
    line-height: 25px;
  }
}

.content {
  margin-top: 25px;

  .title-icon {
    width: 28px;
  }

  .seal-img {
    padding: 5px;
    border: 1px solid #eee;
  }

  .left-content {
    width: 385px;
  }

  .right-content {
    margin-left: 25px;
    padding: 20px 30px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);
  }

  .left-top {
    height: 280px;
    padding: 20px 25px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.05);
  }

  .w80 {
    width: 80px;
  }

  .w100 {
    width: 100px;
  }

  .w200 {
    height: 120px;
  }
}
</style>
